import React from "react";
import { useSelector } from "react-redux";
import { useOutletContext } from "react-router";
import { Navigate } from "react-router-dom";
import { getPayableSession } from "selectors/payableSession";
import { ISession } from "types/session";

export interface IPublicRouteProps {
  /**
   * The element to render if no active session is found, or if `navToPath` is not provided.
   */
  element: JSX.Element;
  /**
   * The path to navigate to when there is an active session.
   */
  navToPath?: string;
}

export const PublicRoute = ({ element, navToPath }: IPublicRouteProps) => {
  const session = useOutletContext<ISession>();
  const payableSession = useSelector(getPayableSession);

  const hasActiveSession = Boolean(payableSession || session?.account);

  if (hasActiveSession && navToPath) {
    return <Navigate to={navToPath} replace />;
  }

  return element;
};
